<template>
  <div class="main_container">
    <div class="container_logo order-md-2" id="container_logo">
      <img class="logo_img" :src="tenant.logoLight" alt />
    </div>
    <div class="contents">
      <div class="container">
        <div
          class="row align-items-center justify-content-center"
          style="margin: auto"
        >
          <div class>
            <img
              src="@/assets/img/icones_servicos.png"
              alt="icon"
              style="height: 30px"
            />
            <h3>
              Central
              <strong>{{ tenant.name }}</strong>
            </h3>
            <p class="mb-4 f16">
              Em nossa central do assinante você consegue abrir chamado,
              visualizar boletos,
              <br />atualizar dados e muito mais!.
            </p>
            <form @submit.prevent="submit">
              <div class="form-group first">
                <label for="username">Usuário</label>
                <input
                  v-model="taxId"
                  type="text"
                  class="form-control"
                  placeholder="Digite seu CPF..."
                  id="username"
                />
              </div>
              <div class="form-group last">
                <label for="password">Senha</label>
                <input
                  v-model="password"
                  type="password"
                  class="form-control"
                  placeholder="Digite sua senha..."
                  id="password"
                />
              </div>

              <button
                type="submit"
                class="btn btn-login mt-3"
                style="width: 100%"
                id="btn-login"
              >
                Entrar
              </button>
            </form>

            <div v-show="isTeknet">
              <hr class="mt-3" />
              <div class="teknetLogin">
                <h3>Central <strong>SGP</strong></h3>
                <p class="mb-4 f16">
                  Caso não consiga entrar, tente na central do assinante SGP
                  clicando no botão abaixo
                </p>
                <a
                  href="http://168.195.171.112:8000/accounts/central/login/?metodo=cpfcnpj"
                  target="blank"
                  ><button
                    class="btn btn-login mt-3"
                    style="width: 100%"
                    id="btn-login"
                  >
                    Central SGP
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapActions } from "vuex";

export default {
  data: function() {
    return {
      isLoading: false,
      taxId: "",
      password: ""
    };
  },
  computed: {
    isTeknet() {
      return window.location.hostname.includes("teknet");
    }
  },
  methods: {
    ...mapActions(["login", "fetchUser"]),
    async submit() {
      this.isLoading = true;

      const loader = this.$loading.show({
        color: "#A9CD84",
        lockScroll: true,
        container: this.$refs.formContainer,
        canCancel: false
      });

      try {
        const { data } = await this.login({
          taxId: this.taxId,
          password: this.password
        });
        this.$gtag.config({ user_id: data.user.id });

        await this.fetchUser();

        this.isLoading = false;
        loader.hide();

        this.$router.push("/");
      } catch (err) {
        this.isLoading = false;
        loader.hide();

        if (err.response) {
          if (err.response.status === 403) {
            Swal.fire("Ops!", "Muitas tentativas erradas de login.", "error");
            return;
          }
          let html = "CPF ou senha incorreta.";
          if (this.isTeknet) {
            html =
              "CPF/senha incorreta.<br><br>Caso não consiga entrar, tente na central do assinante SGP";
          }
          Swal.fire({ title: "Ops!", html, icon: "error" });
        } else {
          Swal.fire(
            "Ops!",
            "Não foi possível conectar com o servidor.",
            "error"
          );
        }
      }
    }
  }
};
</script>

<style scoped>
.logo_img {
  max-height: 600px;
}
.contents {
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  width: 50%;
}
.main_container {
  height: 100vh;
  display: flex;
  flex-wrap: wrap;
}
.container_logo {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  height: 100%;
  background-color: var(--primary-color);
}
.form-group {
  border: 1px solid #c1c1c1;
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
  padding: 15px;
}
.form-control {
  font-size: 20px;
}
.btn {
  height: 54px;
  padding-left: 30px;
  padding-right: 30px;
}
a {
  text-decoration: underline !important;
}

p {
  color: #9b9797;
  font-weight: 300;
}
p.f16 {
  font-size: 16px;
}

a {
  -webkit-transition: 0.3s all ease;
  -o-transition: 0.3s all ease;
  transition: 0.3s all ease;
}
a:hover {
  text-decoration: none !important;
}

.content {
  padding: 7rem 0;
}

h3 {
  font-size: 30px;
}

.half,
.half .container > .row {
  height: 100vh;
}

@media (max-width: 991.98px) {
  .half .bg {
    height: 500px;
  }
}

.half .contents,
.half .bg {
  width: 50%;
}
@media (max-width: 1199.98px) {
  .half .contents,
  .half .bg {
    width: 100%;
  }
}
.half .contents .form-group,
.half .bg .form-group {
  margin-bottom: 0;
  border: 1px solid #efefef;
  padding: 15px 15px;
  border-bottom: none;
}
.half .contents .form-group.first,
.half .bg .form-group.first {
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
  border: 1px solid #c1c1c1;
}
.half .contents .form-group.last,
.half .bg .form-group.last {
  border-bottom: 1px solid #efefef;
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
  border: 1px solid #c1c1c1;
}
.half .contents .form-group label,
.half .bg .form-group label {
  font-size: 12px;
  display: block;
  margin-bottom: 0;
  color: #b3b3b3;
}
.half .contents .form-control,
.half .bg .form-control {
  border: none;
  padding: 0;
  font-size: 20px;
  border-radius: 0;
}
.half .contents .form-control:active,
.half .contents .form-control:focus,
.half .bg .form-control:active,
.half .bg .form-control:focus {
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.half .bg {
  background-size: cover;
  background-position: center;
}

.half .forgot-pass {
  position: relative;
  top: 2px;
  font-size: 14px;
}

.control {
  display: block;
  position: relative;
  padding-left: 30px;
  margin-bottom: 15px;
  cursor: pointer;
  font-size: 14px;
}
.control .caption {
  position: relative;
  top: 0.2rem;
  color: #888;
}

.control input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

.control__indicator {
  position: absolute;
  top: 2px;
  left: 0;
  height: 20px;
  width: 20px;
  background: #e6e6e6;
  border-radius: 4px;
}

.control--radio .control__indicator {
  border-radius: 50%;
}

.control:hover input ~ .control__indicator,
.control input:focus ~ .control__indicator {
  background: #ccc;
}

.control input:checked ~ .control__indicator {
  background: #007bff;
}

.control:hover input:not([disabled]):checked ~ .control__indicator,
.control input:checked:focus ~ .control__indicator {
  background: #1a88ff;
}

.control input:disabled ~ .control__indicator {
  background: #e6e6e6;
  opacity: 0.9;
  pointer-events: none;
}

.control__indicator:after {
  font-family: "icomoon";
  content: "\e5ca";
  position: absolute;
  display: none;
  font-size: 16px;
  -webkit-transition: 0.3s all ease;
  -o-transition: 0.3s all ease;
  transition: 0.3s all ease;
}

.control input:checked ~ .control__indicator:after {
  display: block;
  color: #fff;
}

.control--checkbox .control__indicator:after {
  top: 50%;
  left: 50%;
  margin-top: -1px;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.control--checkbox input:disabled ~ .control__indicator:after {
  border-color: #7b7b7b;
}

.control--checkbox input:disabled:checked ~ .control__indicator {
  background-color: #7e0cf5;
  opacity: 0.2;
}

.btn-login {
  background-color: var(--primary-color);
  color: #fff;
}

@media (max-width: 767px) {
  .contents {
    height: 50%;
    width: unset;
  }
  .container_logo {
    height: 10%;
    width: 100%;
  }
  .logo_img {
    max-height: 120px;
  }
}
</style>
